import {
  Box,
  Button,
  Flex,
  IconButton,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { CloseIcon, HamburgerIcon } from "@chakra-ui/icons";
import "./Navbar.css";
import {
  FaFileDownload,
  FaMoon,
  FaProjectDiagram,
  FaSun,
} from "react-icons/fa";
import { AiFillHome } from "react-icons/ai";
import { BsFillPersonFill } from "react-icons/bs";
import { SiMusicbrainz } from "react-icons/si";
import { RiContactsBookFill } from "react-icons/ri";
import { Link } from "react-scroll";

function Navbar() {
  const [isscroll, setisscroll] = useState(false);
  const { toggleColorMode, colorMode } = useColorMode();
  const [display, changeDisplay] = useState("none");

  // const [activeView, setActiveView] = useState("#home")

  // window.addEventListener("scroll",()=>{
  //   const header = document.querySelector(".header");
  //   if(this.scrollY>=80){
  //     header.classList.add("scroll-header");
  //   }else{
  //     header.classList.remove("scroll-header");
  //   }
  // })
  const handleClick = () => {
    console.log("hi");
    return window.open(
      "https://drive.google.com/file/d/1_JcVUDemIdB8U72X8PfD4K7a-5vxQlqF/view?usp=sharing",
      "_blank"
    );
  // const handleClick = () => {
  //   return window.open(
  //     "htthttps://drive.google.com/file/d/1_JcVUDemIdB8U72X8PfD4K7a-5vxQlqF/view?usp=sharing",
  //     "_blank"
  //   );
  };

  function isScrolling() {
    if (window.scrollY > 0) {
      setisscroll(true);
    } else {
      setisscroll(false);
    }
  }
  useEffect(() => {
    window.addEventListener("scroll", isScrolling);
    return () => {
      window.removeEventListener("scroll", isScrolling);
    };
  }, []);

  return (
    <Box
      id="nav-menu"
      className="header"
      color={isscroll ? "orange" : "#040724"}
      bg={isscroll ? "#040724" : "orange"}
      zIndex={7}
      w="100%"
      p="10px 0px"
      boxShadow="md"
      position={"fixed"}
      top={0}
      fontWeight={"900"}
    >
      <Box
        w="90%"
        m="auto"
        display={["flex", "flex", "flex"]}
        alignItems="center"
        justifyContent="space-between"
        position={"sticky"}
      >
        <Box rounded="50%" mt="5px" mb="5px">
          <Box
            className="logo"
            color={isscroll ? "orange" : "#040724"}
            bg={isscroll ? "#040724" : "orange"}
          >
            <span className="last"></span>
            <span className="last">Ayushi </span>
            <span className="last"></span>
            <span className="last">Vashisth</span>
          </Box>
        </Box>

        <Box
          display={["none", "none", "flex"]}
          gap={["auto", "15px", "20px"]}
          justifyContent={["space-around", "space-between", "space-between"]}
          ml="10px"
          alignItems="center"
        >
          <Link
            display="flex"
            to="home"
            className="nav-link home"
            spy={true}
            smooth={true}
            offset={-100}
            duration={500}
            id="forCursor"
          >
            <Text
              fontWeight="500"
              fontSize={["sm", "sm", "lg"]}
              cursor={"pointer"}
              _hover={{ textDecoration: "underline" }}
            >
              Home
            </Text>
          </Link>
          <Link
            display="flex"
            to="about"
            className="nav-link about"
            spy={true}
            smooth={true}
            offset={-100}
            duration={500}
            id="forCursor"
          >
            <Text
              fontWeight="500"
              fontSize={["sm", "sm", "lg"]}
              _hover={{ textDecoration: "underline" }}
              cursor={"pointer"}
            >
              About
            </Text>
          </Link>
          <Link
            display="flex"
            to="skills"
            className="nav-link skills"
            spy={true}
            smooth={true}
            offset={-100}
            duration={500}
            id="forCursor"
          >
            <Text
              fontWeight="500"
              fontSize={["sm", "sm", "lg"]}
              _hover={{ textDecoration: "underline" }}
              cursor={"pointer"}
            >
              Skills
            </Text>
          </Link>
          <Link
            display="flex"
            to="projects"
            className="nav-link projects"
            spy={true}
            smooth={true}
            offset={-100}
            duration={500}
            id="forCursor"
          >
            <Text
              fontWeight="500"
              _active={{ textDecoration: "underlined" }}
              fontSize={["sm", "sm", "lg"]}
              _hover={{ textDecoration: "underline" }}
              cursor={"pointer"}
            >
              Projects
            </Text>
          </Link>
          <Link
            display="flex"
            to="contact"
            className="nav-link contact"
            spy={true}
            smooth={true}
            offset={-100}
            duration={500}
            id="forCursor"
          >
            <Text
              fontWeight="500"
              fontSize={["sm", "sm", "lg"]}
              _hover={{ textDecoration: "underline" }}
              cursor={"pointer"}
            >
              Contact
            </Text>
          </Link>
          <a
            id="resume-link-1"

            href="https://drive.google.com/uc?id=1_JcVUDemIdB8U72X8PfD4K7a-5vxQlqF&export=download"
            rel="noreferrer"
          >
            <Button
              color={isscroll ? "orange" : "#040724"}
              bg={isscroll ? "#040724" : "orange"}
              className="nav-link resume"
              id="resume-button-1"
              variant={"link"}
              fontWeight="500"
              onClick={handleClick}
            >
              <Text fontSize={["sm", "sm", "lg"]}>Resume</Text>
            </Button>
          </a>
          <IconButton
            display={"none"}
            aria-label="toggle theme"
            rounded="full"
            size="md"
            onClick={toggleColorMode}
            _hover={{ color: colorMode === "#13022C" ? "#13022c" : "white" }}
            backgroundColor={colorMode === "#13022C" ? "#d3cedb" : "#13022C"}
            color={isscroll ? "orange" : "#040724"}
          />
        </Box>

        <IconButton
          aria-label="Open Menu"
          bg="none"
          size="lg"
          p="0px"
          _hover={{ bg: "none" }}
          mr={1}
          color={isscroll ? "orange" : "#040724"}
          icon={<HamburgerIcon w="1.5em" h="1.5em" />}
          display={["flex", "flex", "none"]}
          onClick={() => changeDisplay("flex")}
        />
      </Box>

      <Flex>
        <Flex
          w="20%"
          h="100%"
          color={isscroll ? "orange" : "#040724"}
          bg={isscroll ? "#040724" : "orange"}
          zIndex={20}
          pos="fixed"
          top="0"
          right="0"
          overflowY="auto"
          flexDir="column"
          display={display}
        >
          <Flex justify="flex-end">
            <Button
              _hover={{ bg: "#C1B6DB", color: "#13022c" }}
              my={8}
              mx={4}
              p={["15px 15px", "20px 20px", "25px 25px"]}
              // fontSize={["md", "lg", "xl"]}
              bg={isscroll ? "orange" : "#040724"}
              color={isscroll ? "blue" : "orange"}
              border="none"
              variant="solid"
              w={"fit-content"}
              onClick={() => changeDisplay("none")}
            >
              <CloseIcon />
            </Button>
          </Flex>
          <Box
            display="flex"
            gap="30px"
            flexDir="column"
            align="center"
            fontSize="lg"
            color="white"
          >
            <Link
              to="home"
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
              id="forCursor"
              onClick={() => changeDisplay("none")}
              fontSize={["sm", "sm", "lg"]}
            >
              <Button
                _hover={{ bg: "#C1B6DB", color: "#13022c" }}
                mt="10px"
                p={["15px 15px", "20px 20px", "25px 25px"]}
                fontSize={["md", "lg", "xl"]}
                bg={isscroll ? "orange" : "#040724"}
                color={isscroll ? "blue" : "orange"}
                border="none"
                variant="solid"
                m={"auto"}
                w={"fit-content"}
              >
                <AiFillHome />
              </Button>
            </Link>
            <Link
              to="about"
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
              id="forCursor"
              onClick={() => changeDisplay("none")}
              fontSize={["sm", "sm", "lg"]}
            >
              <Button
                _hover={{ bg: "#C1B6DB", color: "#13022c" }}
                mt="10px"
                p={["15px 15px", "20px 20px", "25px 25px"]}
                fontSize={["md", "lg", "xl"]}
                bg={isscroll ? "orange" : "#040724"}
                color={isscroll ? "blue" : "orange"}
                border="none"
                variant="solid"
                m={"auto"}
                w={"fit-content"}
              >
                <BsFillPersonFill />
              </Button>
            </Link>
            <Link
              to="skills"
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
              id="forCursor"
              onClick={() => changeDisplay("none")}
              fontSize={["sm", "sm", "lg"]}
            >
              <Button
                _hover={{ bg: "#C1B6DB", color: "#13022c" }}
                mt="10px"
                p={["15px 15px", "20px 20px", "25px 25px"]}
                fontSize={["md", "lg", "xl"]}
                bg={isscroll ? "orange" : "#040724"}
                color={isscroll ? "blue" : "orange"}
                border="none"
                variant="solid"
                m={"auto"}
                w={"fit-content"}
              >
                <SiMusicbrainz />
              </Button>
            </Link>
            <Link
              to="projects"
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
              id="forCursor"
              onClick={() => changeDisplay("none")}
              fontSize={["sm", "sm", "lg"]}
            >
              <Button
                _hover={{ bg: "#C1B6DB", color: "#13022c" }}
                mt="10px"
                p={["15px 15px", "20px 20px", "25px 25px"]}
                fontSize={["md", "lg", "xl"]}
                bg={isscroll ? "orange" : "#040724"}
                color={isscroll ? "blue" : "orange"}
                border="none"
                variant="solid"
                m={"auto"}
                w={"fit-content"}
              >
                <FaProjectDiagram />
              </Button>
            </Link>
            <Link
              to="contact"
              spy={true}
              smooth={true}
              offset={-100}
              duration={500}
              id="forCursor"
              onClick={() => changeDisplay("none")}
              fontSize={["sm", "sm", "lg"]}
            >
              <Button
                _hover={{ bg: "#C1B6DB", color: "#13022c" }}
                mt="10px"
                p={["15px 15px", "20px 20px", "25px 25px"]}
                fontSize={["md", "lg", "xl"]}
                bg={isscroll ? "orange" : "#040724"}
                color={isscroll ? "blue" : "orange"}
                border="none"
                variant="solid"
                m={"auto"}
                w={"fit-content"}
              >
                <RiContactsBookFill />
              </Button>
            </Link>
            <a
              href="https://drive.google.com/uc?id=1_JcVUDemIdB8U72X8PfD4K7a-5vxQlqF&export=download"
              rel="noreferrer"
            >
              <Button
                variant={"link"}
                fontWeight="500"
                onClick={handleClick}
                _hover={{ bg: "#C1B6DB", color: "#13022c" }}
                mt="10px"
                p={["15px 15px", "20px 20px", "25px 25px"]}
                fontSize={["md", "md", "md"]}
                bg={isscroll ? "orange" : "#040724"}
                color={isscroll ? "blue" : "orange"}
                border="none"
                m={"auto"}
                w={"fit-content"}
              >
                <FaFileDownload />
              </Button>
            </a>
            <Box textAlign="center">
              <IconButton
                aria-label="toggle theme"
                rounded="full"
                size="md"
                display={"none"}
                w={8}
                h={10}
                onClick={toggleColorMode}
                backgroundColor={
                  colorMode === "dark" ? "rgb(26,32,44)" : "#13022C"
                }
                color={colorMode === "dark" ? "#13022C" : "white"}
                icon={colorMode === "dark" ? <FaSun /> : <FaMoon />}
              />
            </Box>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
}

export default Navbar;
